export const items = [
  { label: 'Current Pool' },
  { label: 'Transactions' },
  { label: 'Delegators' }
]
